import UI from './UI';
import Box from '@material-ui/core/Box';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import * as PropTypes from 'prop-types';
import React, { useState } from 'react';
import NonShoutyButton from './UI/NonShoutyButton';

const TableFilterSelect = ({ filter, currentFilter, i18n }) => {
  if (!filter || typeof filter === 'undefined') {
    return null;
  }

  const [anchorEl, setAnchorEl] = useState(null);

  const { label } = filter;
  const name = filter.name || '';
  const values = filter.values || [];
  const selectedItem = values.find(item => item.selected);
  const displayLabel =
    selectedItem && selectedItem.value !== '' ? selectedItem.name : label;

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const onClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box m={0.5} display="inline-block">
      <NonShoutyButton
        variant="outlined"
        color="secondary"
        onClick={handleClick}
        endIcon={<ArrowDropDownIcon />}
      >
        <UI context={{ i18n }} components={displayLabel} />
      </NonShoutyButton>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={onClose}
      >
        {values.map(item => {
          const { name: filterName = '', value: filterValue = '' } = item;
          return (
            <MenuItem
              key={`${filterName}-${filterValue}`}
              onClick={() => {
                onClose();
                const output = currentFilter || {};
                return {
                  test: 'hello',
                };
              }}
            >
              <UI context={{ i18n }} components={filterName} />
            </MenuItem>
          );
        })}
      </Menu>
    </Box>
  );
};

TableFilterSelect.propTypes = {
  filter: PropTypes.shape({
    name: PropTypes.string,
    label: PropTypes.string,
    values: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        value: PropTypes.string,
        selected: PropTypes.bool,
      }),
    ),
  }),
  currentFilter: PropTypes.object,
  i18n: PropTypes.object,
};

TableFilterSelect.defaultProps = {
  currentFilter: undefined,
  filter: undefined,
  i18n: undefined,
};

export default TableFilterSelect;
